import script from "./Parametri.vue?vue&type=script&setup=true&lang=js"
export * from "./Parametri.vue?vue&type=script&setup=true&lang=js"

import "./Parametri.vue?vue&type=style&index=0&id=76f14f87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f14f87"]])

export default __exports__